import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.tertiaryLight,
    subTitle: p => p.tertiaryLight,
    icon: p => p.accentWhite,
    blockTitle: p => p.accentWhite,
    blockParagraph: p => p.tertiaryLight,
    navbarBg: p => p.tertiaryDark,
    socialColor: p => p.tertiaryLight,
    background: p => p.tertiaryDark,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.2)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    subTitle: p => p.tertiaryDark,
    icon: p => p.primaryDark,
    blockTitle: p => p.primaryDark,
    blockParagraph: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryLight,
    socialColor: p => p.tertiaryDark,
    background: p => p.tertiaryLight,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    border: p => `rgba(${hexToRgb(p.accentWhite)}, 0.2)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    subTitle: p => p.tertiaryDark,
    icon: p => p.tertiaryDark,
    blockTitle: p => p.tertiaryDark,
    blockParagraph: p => p.tertiaryDark,
    socialColor: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryExtraLight,
    lightBackground: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    border: p => `rgba(${hexToRgb(p.accentWhite)}, 0.2)`
  }
}
